import script from "./StepCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepCategory.vue?vue&type=script&setup=true&lang=ts"

import "./StepCategory.vue?vue&type=style&index=0&id=6a921e2d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a921e2d"]])

export default __exports__